<div id="report-render-container" style="display: none;"></div>
<div *ngIf="(screenSizeService.isMobile$ | async)" id="mobile_header">
  <div id="header-left"><img src="/img/mobile-logo.svg" (click)="drawer.toggle()" alt="Royal Management System" /></div>
</div>
<mat-drawer-container class="rms-app" [hasBackdrop]="true" id="drawer-container" [style.--app-zoom]="appScale">
  <mat-drawer #drawer
              mode="over"
              [position]="'start'"
              id="side-nav">
    <!-- header + navigation stay the same -->
    <div class="material-icons text-white lg-font text-bold pointer menu-close" (click)="drawer.toggle()" title="Close Menu" *ngIf="isLaptop">close</div>
    <div id="header-left" *ngIf="!(screenSizeService.isMobile$ | async)">
      <img src="/img/mobile-logo.svg" (click)="drawer.toggle()" />
    </div>
    <app-navigation (onSelectNav)="drawer.close()"></app-navigation>
  </mat-drawer>

  <mat-drawer-content>
    <div class="rms-scale-stage">
      <mat-toolbar class="rms-header">
        <button mat-icon-button class="header-menu" (click)="drawer.toggle()" aria-label="Open navigation" [attr.aria-expanded]="drawer.opened">
          <mat-icon>menu</mat-icon>
        </button>
        <div class="header-title">
          <span class="header-section-icon">
            <mat-icon *ngIf="tabs[selectedTabIndex]?.svgIcon" [svgIcon]="tabs[selectedTabIndex].icon"></mat-icon>
            <mat-icon *ngIf="!tabs[selectedTabIndex]?.svgIcon">{{ tabs[selectedTabIndex].icon || 'dashboard' }}</mat-icon>
          </span>
          <h2 [title]="tabs[selectedTabIndex].title || 'RMS'">{{ tabs[selectedTabIndex].title || 'RMS' }}</h2>
        </div>
        <button mat-icon-button class="header-refresh" (click)="refreshActiveTab()" [disabled]="!tabs.length" aria-label="Refresh current screen" title="Reload this screen (unsaved changes and filters will reset)"><mat-icon>refresh</mat-icon></button>
        <app-quick-links class="header-shortcuts"></app-quick-links>
        <button mat-icon-button [matMenuTriggerFor]="openScreens" aria-label="Open screens" title="Open screens"><mat-icon>tab</mat-icon></button>
        <mat-menu #openScreens="matMenu">
          <button mat-menu-item *ngFor="let tab of tabs;let i=index" (click)="navTabService.setSelectedTab(i)"><mat-icon>{{i===selectedTabIndex?'check':'tab'}}</mat-icon>{{tab.title}} <small> · {{i+1}}</small></button>
        </mat-menu>
        <div class="header-account" *ngIf="!(screenSizeService.isMobile$ | async)">
          <app-rts-quick-ticket [compact]="true"></app-rts-quick-ticket>
          <div class="header-notifications"><app-notifications></app-notifications></div>
          <button class="profile-button" [matMenuTriggerFor]="UserMenu" aria-label="Open account menu">
            <span class="profile-copy"><strong>{{ fullName }}</strong><span>{{ email }}</span></span>
            <img [src]="getImageSrc(image)" alt="" />
            <mat-icon>expand_more</mat-icon>
          </button>
        </div>
        <mat-menu #UserMenu="matMenu">
          <button mat-menu-item (click)="createTicket()"><mat-icon>add_comment</mat-icon><span>Create ticket</span></button>
          <a mat-menu-item [href]="'mailto:' + email"><mat-icon>mail_outline</mat-icon><span>{{ email }}</span></a>
          <button mat-menu-item (click)="onLogout()"><mat-icon>logout</mat-icon><span>Logout</span></button>
        </mat-menu>
      </mat-toolbar>

      <!-- Key: let Material manage tab header pagination; dynamicHeight measures better -->
      <mat-tab-group class="workspace-tabs" headerPosition="below"
                     [(selectedIndex)]="selectedTabIndex"
                     (selectedTabChange)="selectTab($event)"
                     [dynamicHeight]="false"
                     animationDuration="0ms"
                     fitInkBarToContent="false"
                     disableRipple="true">

        <div class="tab-container">
          <div>
            <mat-tab *ngFor="let tab of tabs; let i = index" [label]="tab.title">
              <ng-template mat-tab-label>
                <div class="flex space-between mdc-tab-inner-container no-select" title="{{ tab.title }}" (contextmenu)="$event.preventDefault(); tabActionsTrigger.openMenu()">
                  <div class="longText no-select">{{ tab.title }}</div>
                  <button class="tab-actions-trigger" [class.tab-actions-visible]="selectedTabIndex===i" mat-icon-button [matMenuTriggerFor]="tabActions" #tabActionsTrigger="matMenuTrigger" (click)="$event.stopPropagation()" [attr.aria-label]="'Tab actions for '+tab.title"><mat-icon>more_horiz</mat-icon></button>
                  <mat-menu #tabActions="matMenu">
                    <button mat-menu-item [disabled]="i===0" (click)="closeTab(i)">Close tab</button>
                    <button mat-menu-item (click)="closeRelated(i,'others')">Close other tabs</button>
                    <button mat-menu-item [disabled]="i===tabs.length-1" (click)="closeRelated(i,'right')">Close tabs to the right</button>
                  </mat-menu>
                  @if(i != 0 && selectedTabIndex === i){
                  <mat-icon class="workspace-tab-close" role="button" tabindex="0" [attr.aria-label]="'Close ' + tab.title" title="Close tab" (click)="$event.stopPropagation(); closeTab(i)" (keydown.enter)="$event.stopPropagation(); closeTab(i)" (keydown.space)="$event.preventDefault(); $event.stopPropagation(); closeTab(i)">close</mat-icon>
                  }
                </div>
              </ng-template>

              <div id="body">
                <div [hidden]="selectedTabIndex !== i" class="tab-host-shell">
                  <rms-tab-host [component]="tab.component" [data]="tab.data" [active]="selectedTabIndex === i"></rms-tab-host>
                </div>
              </div>
            </mat-tab>
          </div>
        </div>
      </mat-tab-group>
    </div>
    <!-- optional footer kept commented -->
  </mat-drawer-content>
</mat-drawer-container>

